import { useMemo } from "react";
import { Layer, Source } from "react-mapbox-gl";

const CbrsLayer: React.FC = () => {
  const hexLayout = useMemo(() => hexDefaultStyle(), []);

  const circleLayout = useMemo(
    () => circleDefaultStyle({ minZoom: 0, maxZoom: 8 }),
    []
  );

  return (
    <>
      <Source
        id="cell_points_source"
        tileJsonSource={CELL_POINTS_SOURCE_OPTIONS}
      />
      <Layer
        sourceId="cell_points_source"
        sourceLayer="public.cell_points"
        id="cell_points"
        type="circle"
        paint={circleLayout}
      />
      <Source id="cell_hexes_source" tileJsonSource={CELL_HEX_SOURCE_OPTIONS} />
      <Layer
        sourceId="cell_hexes_source"
        sourceLayer="public.cell_h3_res8"
        id="cell_hexes"
        type="fill"
        minZoom={7}
        paint={hexLayout}
      />
      <Layer
        sourceId="cell_hexes_source"
        sourceLayer="public.cell_h3_res8"
        id="cell_hexes_line"
        type="line"
        paint={hexOutlineStyle}
      />
    </>
  );
};

export default CbrsLayer;

//
// Utils
//

export const hexDefaultStyle = () => ({
  "fill-color": CELL_HOTSPOT_COLOR,
  "fill-opacity": 0.4
});

export const circleDefaultStyle = ({ minZoom, maxZoom }: Zoom) => ({
  "circle-color": CELL_HOTSPOT_COLOR,
  "circle-radius": {
    stops: [
      [minZoom, 2],
      [maxZoom, 5]
    ]
  },
  "circle-opacity": [
    "interpolate",
    ["exponential", 1],
    ["zoom"],
    minZoom,
    0.9,
    maxZoom,
    0
  ]
});

const CELL_HEX_SOURCE_OPTIONS = {
  type: "vector",
  url: `https://hotspot-tileserver.helium.wtf/public.cell_h3_res8.json`
};

const CELL_POINTS_SOURCE_OPTIONS = {
  type: "vector",
  url: `https://hotspot-tileserver.helium.wtf/public.cell_points.json`
};

const hexOutlineStyle = {
  "line-color": "#2f3a59",
  "line-width": ["interpolate", ["exponential", 1], ["zoom"], 6.5, 0, 12, 4],
  "line-blur": 4,
  "line-opacity": 1
};

const CELL_HOTSPOT_COLOR = "#D23E72";

interface Zoom {
  minZoom: number;
  maxZoom: number;
}
